import { createSelector } from 'reselect';
import { getPriceTable } from './index'

export const getPriceTableReferenceData = createSelector(
    getPriceTable,
    priceTable => priceTable.referenceData
)

export const getInvestmentSeriesFunds = createSelector(
    getPriceTableReferenceData,
    referenceData => referenceData.investmentSeriesFunds
)
